import React from 'react';
import { Logger } from '../utils';

export default function BandwidthWarning({ setNQWarningClosed, isNQWarningClosed}) {    
    const closeWarning = () => {
        setNQWarningClosed(true);
        Logger("UI.Twilio.Room.BandwidthWarning.Close.Clicked", new Date());
    };
    return (
        isNQWarningClosed ? null : <div className = "bandwidth-warning">
            <div className="details-icon-prepend">
                <div className="icon-col">
                    <span className="icon-signal" />
                </div>
                <div className="details-col">Your network is causing poor connectivity. Try switching to a better network or move closer to a WiFi access point.</div>
            </div>
            <span className="icon-close" onClick={closeWarning} />
      </div>
  );
}
